import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { domain, clientId, audience } from "../auth_config.json";
import { Auth0Plugin } from "./auth";
import VueHtmlToPaper from 'vue-html-to-paper';
import moment from 'moment'
import VueDragDrop from 'vue-drag-drop';
import ZoomOnHover from "vue-zoom-on-hover";

Vue.prototype.moment = moment;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
  }
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueDragDrop);
Vue.use(ZoomOnHover);

const printOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    './assets/orderPrint.css'
  ]
};

Vue.use(VueHtmlToPaper, printOptions);

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'

const VueApp = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default VueApp;